// extracted by mini-css-extract-plugin
export var textInput = "_lh-0";